import { Space, Typography } from 'antd';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Breadcrumb } from 'components/atoms/breadcrumb';
import { IconShell } from 'components/atoms/icon-shell';
import { Header } from 'components/molecules/page/header';
import { ProductiveHeading05 } from 'components/styles';

const { Title } = Typography;

const HeaderTitle = styled(Title)`
  ${ProductiveHeading05};
  margin-bottom: 0px;
`;

const StyledHeader = styled(Header)<{ withBottomPadding?: boolean }>`
  padding-bottom: ${(props) =>
    props.withBottomPadding ? 'var(--spacing-02) !important' : '0'};
`;

export const IntegrationHeader: FC<{
  title: React.ReactNode;
  breadcrumbLink?: string;
  breadcrumbText?: string;
  icon?: React.ReactNode;
  subText?: React.ReactNode;
  tabs?: React.ReactNode;
  learnMoreLink?: React.ReactNode;
}> = ({
  title,
  icon,
  subText,
  tabs,
  breadcrumbLink,
  breadcrumbText,
  learnMoreLink,
}) => {
  return (
    <>
      <StyledHeader
        withBottomPadding={!tabs}
        breadcrumbs={
          <Breadcrumb.Item>
            <Link to={breadcrumbLink ?? '/settings/integrations'}>
              {breadcrumbText ?? <FormattedMessage id="integrations" />}
            </Link>
          </Breadcrumb.Item>
        }
        title={
          <Space align="center">
            {icon ? <IconShell icon={icon} size="small" /> : null}
            <HeaderTitle data-cy="integrations.title" level={4}>
              {title}
            </HeaderTitle>
          </Space>
        }
        subText={
          <>
            {subText} {learnMoreLink}
          </>
        }
        tabs={tabs}
        sticky
      />
      <Helmet>
        <title>{title}</title>
      </Helmet>
    </>
  );
};
